// Top-level App component for the merchant web app.
//
// Composition order matters: ThemeProvider (future) → QueryClient →
// ErrorBoundary (future) → RouterProvider.

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { JSX } from "react";

import { AppRouter } from "@/router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  );
}
